export const marketScrollStyles = {
  container: {
    // display: "flex",
    // flexDirection: "column",
    flex: "0 0 auto",
    cursor: "pointer",
  },
  card: {
    height: "150px",
    width: "152px",
    borderRadius: "10px",
    padding: "45px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "10px",
    // background: "yellow",
    cursor: "pointer",
  },
  marketText: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "20px",
    color: "#546679",
  },
};
